import { p } from "./schema-omMDDyjh.mjs";
import { c as x, t as z } from "./schema-omMDDyjh.mjs";
import { z as i } from "zod";
import { t as c } from "i18next";
import "@mantine/notifications";
import "react";
import "./vanilla-BMQk9Zav.mjs";
import "@mantine/core";
import "./createReactComponent-mYmqlnjV.mjs";
import "clsx";
import "google-libphonenumber";
class U {
  constructor(e) {
    this.fetcher = e;
  }
  async get(e, t, a, s, l) {
    let f = e;
    if (t) {
      const m = new URLSearchParams();
      Object.keys(t).forEach((u) => {
        const o = t[u];
        Array.isArray(o) ? o.forEach((d) => {
          d != null && m.append(u, d);
        }) : o != null && m.append(u, o);
      }), f = `${e}?${m.toString()}`;
    }
    return this.fetcher.request(
      f,
      "GET",
      null,
      a,
      s,
      l
    );
  }
  async post(e, t, a, s, l) {
    return this.fetcher.request(e, "POST", t, a, s, l);
  }
  async update(e, t, a, s) {
    return this.fetcher.request(e, "PUT", t, a, s);
  }
  async delete(e, t, a, s) {
    return this.fetcher.request(e, "DELETE", null, a, s);
  }
  async patch(e, t, a, s) {
    return this.fetcher.request(e, "PATCH", t, a, s);
  }
}
class I {
}
const n = c("common.validation.requiredField"), g = c("common.validation.invalidValue"), h = c("common.validation.invalidEmail"), E = i.string({
  errorMap: (r, e) => e.data === null ? { message: n } : { message: e.defaultError }
}).min(1, { message: n }).max(100), v = i.string({ required_error: n }).email({ message: h }).min(1, { message: n }).max(100), F = i.number({
  errorMap: (r, e) => !e.data || e.data === "" ? { message: n } : { message: e.defaultError }
}).nonnegative(), V = i.coerce.number({
  errorMap: (r, e) => !e.data || e.data === "" ? { message: n } : { message: e.defaultError }
}).nonnegative(), b = i.date({ required_error: n }).min(new Date(1850, 1, 1)).max(/* @__PURE__ */ new Date()), q = (r) => i.string().refine((e) => r.includes(e), { message: g }), y = i.string({
  errorMap: (r, e) => e.data === null ? { message: n } : { message: e.defaultError }
}).min(1, { message: n }).max(100).refine(
  (r) => {
    if (!r)
      return !0;
    try {
      const e = p(r);
      return (e == null ? void 0 : e.isValid) ?? !1;
    } catch {
      return !1;
    }
  },
  { message: "Invalid phone number format" }
), O = {
  textFieldValidator: E,
  emailFieldValidator: v,
  numberFieldValidator: F,
  numberCoerceFieldValidator: V,
  dateFieldValidator: b,
  enumFieldValidator: q,
  phoneNumberValidator: y
};
export {
  I as Fetcher,
  U as HttpClient,
  x as capturePdfFrameIntoHTML,
  z as toast,
  O as validators
};
